<template>
    <a-card :bordered="false" class="m-b-20">
      <a-form ref='form' :model='search' :initialValues="search" layout='inline'>
        <a-form-item label="请选择">
          <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
            <a-select-option value="1">日</a-select-option>
            <a-select-option value="2">自然周</a-select-option>
            <a-select-option value="3">自然月</a-select-option>
            <a-select-option value="4">近7天</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="">
          <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' />
          <a-week-picker v-model:value="weekTime" v-else-if="search.search_date_type=='2'" @change="changeWeek" />
          <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" valueFormat='YYYY-MM' format='YYYY-MM' />
        </a-form-item>
        <a-form-item label="所属经销商" name='to_seller_id'>
          <a-input v-model:value="search.to_seller" readonly placeholder='请选择所属经销商' />
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 3px;" v-if='search.to_seller' @click='search.to_seller="";search.to_seller_id="";' />
        </a-form-item>
        <a-form-item label="" name=''>
          <a-button type="primary" @click='showDealer = true'>选择</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' @click="onSearch">搜索</a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card :bordered="false" class="m-b-20">
      <a-row :gutter="[24,16]">
        <a-col :span="12" class="s_bf">
          <div ref="echartsLeft" style="width:100%;height:400px"></div>
        </a-col>
        <a-col :span="12" class="s_bf">
          <div ref="echartsRight" style="width:100%;height:400px"></div>
        </a-col>
      </a-row>
    </a-card>
    <a-card :bordered="false">
      <div class="m-t-10 m-b-10">门店订货明细</div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
        <template v-slot:action="{ record }">
          <a-button v-has:onlineStaticsStoreDetail="()=>{$router.push({path:'/onlineOrder/statics/storeOrderStatics/detail',query:{buyer_id:record.buyer_id,search_date_type:search.search_date_type,search_time:search.search_time,weekTime:weekTime}})}">查看详情</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
    <a-modal title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null" destroyOnClose>
      <selectDealer v-on:select="dealerSelect"></selectDealer>
    </a-modal>
</template>
<script>
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import useTableSearch from "@/hooks/useTableSearch";
import { statisticsStore, statisticsStoreLog } from "@/api/online";
import { CloseCircleFilled } from "@ant-design/icons-vue";
const def = {
  search_date_type: "1",
  search_time: "",
  to_seller_id: "",
  to_seller: "",
  limit: 10,
  page: 1,
};
export default {
  components: {CloseCircleFilled},
  setup() {
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: def });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    let columns = [
      {
        title: "门店名称",
        dataIndex: "store_name",
        key: "store_name",
      },
      {
        title: "订货积分",
        dataIndex: "order_point_price_total",
        key: "order_point_price_total",
        sorter: (a, b) => a.order_point_price_total - b.order_point_price_total,
      },
      {
        title: "订货次数",
        dataIndex: "order_num_total",
        key: "order_num_total",
        sorter: (a, b) => a.order_num_total - b.order_num_total,
      },
      {
        title: "平均订货积分",
        dataIndex: "order_point_avg",
        key: "order_point_avg",
        sorter: (a, b) => a.order_point_avg - b.order_point_avg,
      },
      {
        title: "成功退款积分",
        dataIndex: "refund_point_price_total",
        key: "refund_point_price_total",
        sorter: (a, b) =>
          a.refund_point_price_total - b.refund_point_price_total,
      },
      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const state = reactive({
      active: "1",
      showDealer: false,
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
   const { dateTargets, typeToStartEnd } = useTime();
    // 切换周
    const momentTime = inject("momentTime");
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = dateTargets();
          break;
        case "2":
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
            dateTime.weekTime=typeToStartEnd("week").end_time
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          break;
      }
    };
    const changeQuarter = (e) => {
      console.log(e);
    };
    const detail=ref()
    const init = async () => {
      let result = await statisticsStore(search.value)
        .then((res) => res.data)
        .catch((error) => error);
      detail.value=result.data
      return true
    };
    // 线性图表
    const echartsLeft = ref("");
    const echartsRight = ref("");
    var left, right;
    onMounted(async() => {
      handleChange("1")
      await init();
      tableHoosks.initData(statisticsStoreLog, search.value);
      setCharts();
    });
    const setCharts = () => {
      left = useECharts(echartsLeft.value);
      right = useECharts(echartsRight.value);
      left.setOptions({
        title: {
          text: "TOP10订货积分排行",
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}<br/>积分：{c}",
          axisPointer: {
            type: "shadow",
          },
        },
        color: ["#748ede"],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: detail.value.order_point_ranking_data.map(v=>v.store_name),
        },
        series: [
          {
            name: "",
            type: "bar",
            data:  detail.value.order_point_ranking_data.map(v=>v.order_point_price_total),
          },
        ],
      });
      right.setOptions({
        title: {
          text: "TOP10订货次数排行",
        },
        tooltip: {
          formatter: "{b}<br/>次数:{c}",
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        color: ["#748ede"],
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: detail.value.order_num_ranking_data.map(v=>v.store_name),
        },
        series: [
          {
            name: "2012年",
            type: "bar",
            data: detail.value.order_num_ranking_data.map(v=>v.order_num_total),
          },
        ],
      });
    };
    const onSearch = async () => {
          await init();
      tableHoosks.initData(statisticsStoreLog, search.value);
      setCharts();
    };
    //选择经销商
    const dealerSelect = (e) => {
      console.log(e);
      if (e == 0) {
        search.value.to_seller = "总部";
        search.value.to_seller_id = e;
      } else {
        search.value.to_seller = e.dealer_name;
        search.value.to_seller_id = e.dealer_id;
      }
      state.showDealer = false;
    };
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      handleChange,
      changeQuarter,
      echartsLeft,
      echartsRight,
      ...tableHoosks,
      columns,
      changeWeek,
      dealerSelect,
      onSearch,
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
</style>